const model = {
    categoryDetails: null,
    loading: false,
    error: null,
};

export default model;
